export default __webpack_public_path__ + "static/Bm_ELIB_EzyMedical_Declaration-33f172975118d9d8dfab9208577c58d9.pdf";